import './blip-email-preview.css'

export function BlipEmailPreview({ html, title = 'Formatted Blip email preview', openByDefault = false }: { html: string; title?: string; openByDefault?: boolean }) {
  if (!html) return null
  const srcDoc = '<!doctype html><html><head><meta name="viewport" content="width=device-width,initial-scale=1"><meta name="referrer" content="no-referrer"></head><body style="margin:16px;background:white">' + html + '</body></html>'
  return <details className="blip-email-preview" open={openByDefault}>
    <summary>View formatted sent email</summary>
    <p>Read-only rendering from the saved sent-message evidence.</p>
    <iframe title={title} sandbox="" referrerPolicy="no-referrer" loading="lazy" srcDoc={srcDoc}/>
  </details>
}
